import gql from 'graphql-tag'

import { pageInfoData } from './common'

export const standardCompanyResult = gql`
	fragment standardCompanyResult on Company {
		id
		_OwnerToCompanyCollection {edges{node{
			user{id
			uid}}}
		}
		name
		slug
		dateFounded
		industry {
			id
			key
		}
		headline
		description
		productsAndServices
		noOfEmployees
		companyOfficesCollection {edges{node{
			id
			address
			roLocations {
				id
				name
				region2
			}
			zipCode
			hq}}
		}
		website
		phones
		emails
		featuredVideo
		hasLogo
		logoPath
		hasCover
		aboutTeams
		coverPath
		jobCollection{
			edges{
				node{
					id
				}
			}
		}
		# hasJobs
		__typename}
	
`

export const companyOfficesResult = gql`
	fragment companyOfficesResult on CompanyOffices {
		id
		roLocations {
			id
			region2
			name
		}
		address
		zipCode
		hq
	}
`

export const companyConnectionData = gql`
	fragment Node on Company {
	
				...standardCompanyResult
		
	}
	${standardCompanyResult}
	${pageInfoData}
`
